import { render, staticRenderFns } from "./addAnnualPlan.vue?vue&type=template&id=5b64f3ba&scoped=true"
import script from "./addAnnualPlan.vue?vue&type=script&lang=js"
export * from "./addAnnualPlan.vue?vue&type=script&lang=js"
import style0 from "./addAnnualPlan.vue?vue&type=style&index=0&id=5b64f3ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b64f3ba",
  null
  
)

export default component.exports